import { navigateTo } from '#imports'

import type { ApiSpecs } from '@backmarket/nuxt-module-http-v2/specs'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'

import { getAvailableItems } from '~/scopes/checkout/utils/cart'

export function useRedirectIfCartEmpty(currentStep: string) {
  const logger = useLogger()

  const redirectIfCartEmpty = async (
    items: ApiSpecs['/bm/cart']['GET']['response']['cartItems'],
    targetStep: string,
  ) => {
    const availableItems = getAvailableItems(items)

    if (availableItems.length === 0) {
      logger.info(`[CHECKOUT][${currentStep}] No available items in the cart`, {
        cartItems: items,
        owners: ['bot-squad-checkout-front'],
      })

      await navigateTo({ name: targetStep })
    }
  }

  return { redirectIfCartEmpty }
}
